import { useState, useRef, useEffect } from 'react';

// useTimePlayback, the time-scrubber playback engine, shared by the desktop
// TimeScrubber and the mobile time transport (MobilePaneLayers) so play/pause,
// speed, and the ±72h range behave identically on both. The engine advances the
// caller's `offset` (seconds, relative to live "now") via onScrub on a 100ms
// tick scaled by `speed`, and auto-stops at +72h.
export const TIME_MAX_S = 259200; // 72h in seconds

export function useTimePlayback(offset, onScrub) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [speed,     setSpeed]     = useState(60);
  const offsetRef = useRef(offset);
  useEffect(() => { offsetRef.current = offset; }, [offset]);

  useEffect(() => {
    if (!isPlaying) return undefined;
    const id = setInterval(() => {
      const next = Math.round(offsetRef.current + (100 * speed / 1000));
      if (next >= TIME_MAX_S) { onScrub(TIME_MAX_S); setIsPlaying(false); return; }
      onScrub(next);
    }, 100);
    return () => clearInterval(id);
  }, [isPlaying, speed, onScrub]);

  return { isPlaying, setIsPlaying, speed, setSpeed };
}

// Format a signed second-offset as a LIVE / T±h m label.
export function fmtTimeOffset(sec) {
  if (sec === 0) return 'LIVE';
  const abs  = Math.abs(sec);
  const sign = sec > 0 ? 'T+' : 'T-';
  const h    = Math.floor(abs / 3600);
  const m    = Math.floor((abs % 3600) / 60);
  if (h === 0) return sign + m + 'm';
  if (m === 0) return sign + h + 'h';
  return sign + h + 'h ' + String(m).padStart(2, '0') + 'm';
}
